<template>
  <div>
    <section
      class="relative -mt-20 pt-20"
      ref="container"
    >
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
export default {
  name: 'account-view',
  watch: {
    async $route() {
      await this.$store.dispatch('billing/getPrices');
    },
  },
  async mounted() {
    if (this.$store.getters['account/isAccountOwner']) {
      await this.$store.dispatch('billing/initBillingAPI');
    }
  },
};
</script>
